const styles = theme => ({
  root: {
    marginTop: 10,
    marginBottom: 12,
    alignItems: 'center',
    textAlign: 'center',
    marginLeft: 12,
    width: 'calc(100% - 48px)',
    borderRadius: 5,
    [theme.breakpoints.up('sm')]: {
        marginTop: 10,
        marginLeft: 'calc( (100% - 400px) * 0.5)',
        width: 400,
    },
    [theme.breakpoints.up('md')]: {
        marginTop: 10,
        marginLeft: 'calc( (100% - 400px) * 0.5)',
        width: 400,
    },
  },
  space1: {
    marginTop: 20
  },
  bottom: {
    paddingBottom: 20,
  },
  actions: {
    marginTop: 25,
    marginBottom: 12,
    alignItems: 'center',
    textAlign: 'center',
  },
  text:{
    margin: 10,
    padding: 5,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/AllCommunication/scenes/outbound/styles.js